<!--
  This is for finding a restaurant via places api search
  selected restaurant is checked against our internal database
  options are then given to add if not there or use if it is.

-->

<script setup>
import { ref } from 'vue'
import restaurntPin1 from '@/assets/images/maps/restaurant-waiter-icon.svg'
import {useReservationsStore, useRestaurantsStore, useUsersStore} from "@/stores"
import {
  emailValidator,
  requiredValidator,
} from '@validators'

import {useRoute} from "vue-router"

import logo from '@/assets/logo.svg'

const props = defineProps({
  member: {
    type: Object,
  }
})
const emit = defineEmits([
  'onClose'
])
const route = useRoute()
const router = useRouter()


const showingDialog = ref(true)

const usersStore = useUsersStore()
let myUser = null;
({ myUser } = storeToRefs(usersStore))
</script>

<template>
  <VDialog
    v-if="member"
    v-model="showingDialog"
    :width="$vuetify.display.mdAndDown ? '100%' : 650 "
    persistent
    fullscreen
    no-click-animation
    :retain-focus="false"
  >
    <VCard class="">
      <VToolbar
        density="compact"
      >
        <VToolbarItems>
          <VBtn
            icon="$close"
            size="large"
            variant="text"
            @click="emit('onClose')"
          >
            <VIcon>mdi-chevron-left</VIcon>
          </VBtn>
        </VToolbarItems>
        <VSpacer />
        <span>Member Profile</span>
        <VSpacer />
        <VToolbarItems style="width: 58px" />
      </VToolbar>

      <div class="ma-1">
        <Profile
          class="pa-2"
          :member="member"
        />
      </div>
    </VCard>
  </VDialog>
</template>

<style scoped>
.no-outline {
  outline: none;
}

.toolbar-headline {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.headline-title{
  font-family: var(--heading-font);
  font-weight: 400;
  color: var(--ds-text-strong);
  font-size: 1.4rem;
  line-height: 1em;
}
</style>
